import router from "./router";
import store from "./store";
import History from "@/utils/history";
import Vue from "vue";
import { Toast } from "cube-ui";

Vue.use(Toast);

const isAllowedBrowser = () => {
  const ua = navigator.userAgent;
  // 傲游浏览器（UA含Chrome，需单独排除）
  if (ua.indexOf("Maxthon") > -1) return false;
  // 2345浏览器（UA含Chrome，需单独排除）
  if (ua.indexOf("2345Explorer") > -1) return false;
  // 猎豹浏览器（UA含Chrome，需单独排除）
  if (ua.indexOf("LBBrowser") > -1) return false;
  // 搜狗浏览器（UA含Chrome，需单独排除）
  if (ua.indexOf("SogouMobileBrowser") > -1) return false;
  // Opera（UA含Chrome，需单独排除）
  if (ua.indexOf("OPR") > -1) return false;
  // QQ浏览器（UA含Chrome，需单独排除）
  if (ua.indexOf("QQBrowser") > -1) return false;
  // 夸克浏览器（UA含Chrome，需单独排除）
  if (ua.indexOf("Quark") > -1) return false;
  // UC浏览器（UA含Chrome，需单独排除）
  if (ua.indexOf("UCBrowser") > -1 || ua.indexOf("UCWEB") > -1) return false;
  // Google Chrome (Edge UA also contains "Chrome", exclude it)
  if (ua.indexOf("Chrome") > -1 && ua.indexOf("Edg") === -1) return true;
  // Edge
  if (ua.indexOf("Edg") > -1) return true;
  // IE
  if (ua.indexOf("MSIE") > -1 || ua.indexOf("Trident") > -1) return true;
  // Huawei browser
  if (ua.indexOf("Huawei") > -1 || ua.indexOf("HUAWEI") > -1) return true;
  // 360 browser
  if (ua.indexOf("360") > -1 || ua.indexOf("360SE") > -1 || ua.indexOf("QIHU") > -1) return true;
  // Safari (Safari UA contains "Safari" but not "Chrome")
  if (ua.indexOf("Safari") > -1 && ua.indexOf("Chrome") === -1) return true;
  return false;
};

const getUserInfo = next => {
  store
    .dispatch("GetUserInfo")
    .then(res => {
      if (!res) {
        throw "获取用户信息异常";
      }
    })
    .catch(err => {
      store.dispatch("FedLogOut").then(() => {
        const toast = Toast.$create({
          txt: err,
          type: "error",
          time: 2000
        });
        toast.show();
        setTimeout(() => {
          next({
            path: "/redirect/login"
          });
        }, 2000);
      });
    });
};
// 守卫
router.beforeEach((to, from, next) => {
  const hasGreenChannel = localStorage.getItem("greenChannelAccess") === "1";
  if (
    to.path !== "/browser" &&
    to.path !== "/registered" &&
    to.path !== "/ua" &&
    to.path !== "/green" &&
    !hasGreenChannel &&
    !isAllowedBrowser()
  ) {
    next({ path: "/browser" });
    return;
  }
  if (to.meta.auth) {
    // 路由权限校验
    if (store.getters.token) {
      if (!store.getters.name) {
        getUserInfo(next);
      }
      next();
    } else {
      next({
        path: "/login",
        query: {
          redirect: to.path
        }
      });
    }
  } else {
    if (to.path == '/' && !store.getters.token) {
      next('/login');
    } else {
      if (store.getters.token) {
        if (!store.getters.name) {
          getUserInfo(next);
        }
      }
      next();
    }
  }
});

// afterEach记录历史记录
router.afterEach(to => {
  if (router.isBack) {
    // 后退
    History.pop();
    router.isBack = false;
    router.transitionName = "route-back";
  } else {
    History.push(to.path);
    router.transitionName = "route-forward";
  }
});